import { useEffect, useState } from "react";
import eventEmitter from "../../../shared/events";

// Set the name of the hidden property and the change event for visibility
var hidden, visibilityChange;

if (typeof document.hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    hidden = "hidden";
    visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}

export function useWindowVisible() {
    const [isPaused, setIsPaused] = useState(false);
    const [isWindowVisible, setIsWindowVisible] = useState(true);

    useEffect(() => {
        eventEmitter.on("PAUSE_WINDOW_VISIBLE", updateWindowVisible);

        return () => {
            eventEmitter.removeListener("PAUSE_WINDOW_VISIBLE", updateWindowVisible);
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (isPaused) {
                return;
            }

            if (document[hidden]) {
                setIsWindowVisible(false);
            } else {
                setIsWindowVisible(true);
            }
        };
        window.addEventListener(visibilityChange, handleVisibilityChange, false);

        return () => {
            window.removeEventListener(visibilityChange, handleVisibilityChange);
        };
    }, [isPaused]);

    const updateWindowVisible = (bool) => {
        setIsPaused(bool);
    };

    return isWindowVisible;
}
